import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { Link, withRouter } from "react-router-dom";
import { message } from "antd";

import {
	Col,
	Button,
	Card,
	Descriptions,
	Row,
	Form,
	Input,
	Select,
	Typography,
} from "antd";
import VHSpinner from "../../../../ui/VHSpinner";
import { isEmpty } from "lodash";
import ConfirmationDetails from "../ConfirmationDetails";
import { defaultCurrencyFormat } from "../../../../../utilities";

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import StripeForm from "../../../../ui/forms/StripeForm";


const BASE_API_URL = process.env.INSURFORCE_BASE_API_URL;

const STRIPE_CONNECTED_ACCOUNT_KEY = `${process.env.REACT_APP_STRIPE_CONNECTED_ACCOUNT_ID}`;
const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
const promise = loadStripe(STRIPE_KEY, {
	stripeAccount: STRIPE_CONNECTED_ACCOUNT_KEY,
});
/**
 * Asks for user confirmation for a given quote.
 */
@inject("context")
@withRouter
@observer
class MtaConfirm extends Component {
	constructor(props) {
		super(props);
		this.myRefPremium = React.createRef();
		this.myRefadmin_fee = React.createRef();
		this.myRefCommission = React.createRef();
		this.myRefCommissionRate = React.createRef();
		this.state = {
			showCard: false,
			clientSecret: '',
			isUpdateButtonClicked: false,
			isStatusOk: false,
			agent_commission: 0,
			agent_commission_rate: 0, // TODO
			admin_fee: 0,
			net_premium: 0,
			new_premium: 0, // gross_premium
			gross_premium: 0, // gross_premium
			ipt_amt: 0,
			total: 0,
			totalPaid: 0,
			totalDueRefund: 0,

			originals: {
				agent_commission: null,
				agent_commission_rate: null,
				admin_fee: null,
			},
		};
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleCalulateTotal = this.handleCalulateTotal.bind(this);
	}




	paymentDueRefundNegative(quoteForPayment) {

		const { insuranceMtaService, applicationService } = this.props.context;
		const { insuranceForMta } = insuranceMtaService;
		const updatedQuote = insuranceForMta.amendedQuoteData.quoteId;


		const amount = Math.round((quoteForPayment.total + Number.EPSILON) * 100);
		let paymentIntent = {
			amount: Math.abs(Math.round((this.state.totalDueRefund + Number.EPSILON) * 100)),
			currency: "gbp",
			quoteId: updatedQuote, // causing error in backend, we need to send amended quoteId as new quoteId
			stripePaymentPurpose: quoteForPayment.stripePaymentPurpose,
			net_premium: quoteForPayment.net_premium,
			new_premium: quoteForPayment.new_premium,
			agent_commission: quoteForPayment.agent_commission,
			agent_commission_rate: quoteForPayment.agent_commission_rate,
			gross_premium: quoteForPayment.gross_premium,
			admin_fee: quoteForPayment.admin_fee,
			ipt_amt: quoteForPayment.ipt_amt,
			total: quoteForPayment.total,
			totalDueRefund: quoteForPayment.totalDueRefund,
			/* totalDueRefund: this.state.totalDueRefund, */
			edited: quoteForPayment.edited,
			isMtaPolicy: quoteForPayment.isMtaPolicy,
		};
		fetch(`${BASE_API_URL}/api/v1/payment-intent/refund`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(paymentIntent),
		})

			.then((res) => {
				// setClientSecret(data.clientSecret);
				if (res.status === 200 || res.statusText === "OK") {

					this.setState({
						/* 		clientSecret: data.clientSecret, */
						// for refund payment fix
						isStatusOk: true,
					});

				} else {

					this.setState({
						isUpdateButtonClicked: false
					});
					message.error("Something went wrong, please try again later or contact administrator.");
					this.props.history.push("/policies");
				}
			})
			.catch((err) => {

				this.setState({

					isUpdateButtonClicked: false
				});

			});
	}






	sendPaymentIntent(quoteForPayment) {
		const { insuranceMtaService, applicationService } = this.props.context;
		const { insuranceForMta } = insuranceMtaService;
		const updatedQuote = insuranceForMta.amendedQuoteData.quoteId;

		const amount = Math.round((quoteForPayment.total + Number.EPSILON) * 100);
		let paymentIntent = {
			amount,
			currency: "gbp",
			quoteId: updatedQuote, // causing error in backend, we need to send amended quoteId as new quoteId
			stripePaymentPurpose: quoteForPayment.stripePaymentPurpose,
			net_premium: quoteForPayment.net_premium,
			new_premium: quoteForPayment.new_premium,
			agent_commission: quoteForPayment.agent_commission,
			agent_commission_rate: quoteForPayment.agent_commission_rate,
			gross_premium: quoteForPayment.gross_premium,
			admin_fee: quoteForPayment.admin_fee,
			ipt_amt: quoteForPayment.ipt_amt,
			total: quoteForPayment.total,
			totalDueRefund: quoteForPayment.totalDueRefund,
			/* 	totalDueRefund: this.state.totalDueRefund, */
			edited: quoteForPayment.edited,
			isMtaPolicy: quoteForPayment.isMtaPolicy,
		};

		fetch(`${BASE_API_URL}/api/v1/payment-intent`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(paymentIntent),
		})
			.then((res) => {
				return res.json();
			})
			.then((data) => {
				// setClientSecret(data.clientSecret);
				if (data && typeof data.clientSecret === 'string') {
					this.setState({
						clientSecret: data.clientSecret
					});
				} else {
					this.setState({
						isUpdateButtonClicked: false
					});
				}
			})
			.then(() => {
				// call api to send email , send updatedQuote as quoteId
				console.log("send email api call", updatedQuote);
				fetch(`${BASE_API_URL}/api/v1/portal/documents/${updatedQuote}`, {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
					},
				})
					.then((res) => {
						message.success("Email sent successfully");
						console.log(res);
					})
					.catch((err) => {
						message.error("Something went wrong, please try again later or contact administrator.");
					});
			})
			.catch((err) => {
				console.log(err);

				this.setState({
					isUpdateButtonClicked: false
				});
				this.props.history.push(`/error`);
			});
	}



	handleInputChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;
		// We only allow them to change the agent_commission
		//		if (name === "agent_commission_rate") {
		//			// if we change commission rate we need to calculate commission amount
		//			const agent_commission = this.state.gross_premium * value;
		//			this.setState({
		//				agent_commission_rate: value,
		//				agent_commission: agent_commission,
		//				gross_premium: Number(this.state.net_premium) + agent_commission,
		//				ipt_amt: (Number(agent_commission) + Number(this.state.net_premium)) * 0.12
		//			});
		//		} else 
		if (name === "agent_commission") {
			// if we change commission amount we need to calculate commission rate
			this.setState({
				agent_commission: value,
				agent_commission_rate: (Number(value) / (Number(value) + Number(this.state.net_premium))),
				gross_premium: Number(value) + Number(this.state.net_premium),
				ipt_amt: (Number(value) + Number(this.state.net_premium)) * 0.12
			});
		} else {
			this.setState({
				[name]: value,
			});
		}
	}

	handleCalulateTotal(e) {

		const total = Number(this.state.net_premium) + // E6
			Number(this.state.agent_commission) + // E7
			Number(this.state.ipt_amt) + // E10
			Number(this.state.admin_fee); // E9
		const totalDueRefund = total - Number(this.state.totalPaid);
		this.setState({
			total: total,
			totalDueRefund: totalDueRefund,
		});
	}

	clickShowCard = () => {
		this.setState((state) => ({
			showCard: !state.showCard,
		}));
	};

	componentDidUpdate(prevProps, prevState) {

	}

	async componentDidMount() {

		const { policyNumber, quoteId } = this.props.match.params; //
		const { insuranceMtaService, applicationService } = this.props.context;
		const { insuranceForMta } = insuranceMtaService;

		const agent_commission_rate = (insuranceForMta.amendedQuoteData.agent_commission / insuranceForMta.amendedQuoteData.gross_premium).toFixed(2);
		this.setState({
			agent_commission: insuranceForMta.amendedQuoteData.agent_commission, // form state
			agent_commission_rate: agent_commission_rate, // form state
			admin_fee: insuranceForMta.amendedQuoteData.admin_fee, // form state
			ipt_amt: insuranceForMta.amendedQuoteData.ipt_amt,
			net_premium: insuranceForMta.amendedQuoteData.net_premium,
			gross_premium: insuranceForMta.amendedQuoteData.gross_premium,
			new_premium: insuranceForMta.amendedQuoteData.gross_premium,
			total: insuranceForMta.amendedQuoteData.total,
			totalPaid: insuranceForMta.total,
			totalDueRefund: insuranceForMta.totalDueRefund,
			originals: {
				agent_commission: insuranceForMta.amendedQuoteData.agent_commission,
				agent_commission_rate: insuranceForMta.amendedQuoteData.agent_commission_rate,
				admin_fee: insuranceForMta.amendedQuoteData.admin_fee,
			}
		});

		if (!isEmpty(insuranceMtaService.insuranceForMta)) {
			return;
		}

		if (applicationService.isAuthenticated) {
			this.props.history.push("/policies");
		} else {
			if (policyNumber) {
				//TODO console.log("TODO POLICIES");
			}
			if (quoteId) {
				// TODO console.log("TODO QUOTES");
			}
		}
	}

	render() {
		const { insuranceMtaService } = this.props.context;
		const { insuranceForMta, clientData } = insuranceMtaService;
		const { startDate } = clientData;
		const { isViewMode } = this.props.context.policiesService;

		if (isEmpty(insuranceForMta)) {
			return <VHSpinner />;
		}


		const { policyNumber } = insuranceForMta;
		const { quoteId } = insuranceForMta;
		const { showCard } = this.state;
		const { isUpdateButtonClicked, clientSecret, isStatusOk } = this.state;



		// if we update the quote return true
		const areWeUpdatingQuoteOrPolicy = () => {
			if (policyNumber) {
				return false;
			}
			return true;
		};


		let isMtaPolicy = false;
		if (policyNumber) {
			isMtaPolicy = true;
		}


		let isEdited = false;
		if (Number(this.state.agent_commission) !== this.state.originals.agent_commission || Number(this.state.admin_fee) !== this.state.originals.admin_fee) {

			isEdited = true;
		}


		const quoteForPayment = {
			total: insuranceForMta.amendedQuoteData.total,
			quoteId: insuranceForMta.quoteId,
			hashedTotalDueRefund: "no",
			stripePaymentPurpose: "QUOTE",
			net_premium: this.state.net_premium,
			agent_commission: this.state.agent_commission,
			agent_commission_rate: this.state.agent_commission_rate,
			gross_premium: this.state.gross_premium,
			admin_fee: this.state.admin_fee,
			ipt_amt: this.state.ipt_amt,
			total: this.state.total,
			totalDueRefund: this.state.totalDueRefund,
			edited: isEdited,
			isMtaPolicy,
		};




		return (
			<DefaultLayout>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Confirmation</h1>}>
							<Row>
								<Col xs={24} />
							</Row>
							<Row>
								<Col xs={24}>
									<ConfirmationDetails
										clientDataTitle={
											<Typography.Title level={4}>
												Your details
											</Typography.Title>
										}
										insuranceDataTitle={
											<Typography.Title level={4}>
												Current policy
											</Typography.Title>
										}
										clientData={insuranceForMta}
										insuranceData={insuranceForMta}
										areWeUpdatingQuoteOrPolicy={areWeUpdatingQuoteOrPolicy()}
										startingDateForQuote={startDate}
									/>
									<Descriptions

										title={
											<Typography.Title level={4}>
												Amended Policy
											</Typography.Title>
										}
										bordered
										size="small"
										column={1}
										style={{
											marginTop: "2rem",
											visibility: isViewMode ? "collapse" : "visible"
										}}
									>
										<Descriptions.Item label="Insurer">
											{insuranceForMta.amendedQuoteData.insurer}
										</Descriptions.Item>
										<Descriptions.Item label="Gross Premium">
											{defaultCurrencyFormat(
												this.state.gross_premium

											)}
										</Descriptions.Item>

										<Descriptions.Item label="Net Premium">
											{defaultCurrencyFormat(
												insuranceForMta.amendedQuoteData.net_premium
											)}
										</Descriptions.Item>

										<Descriptions.Item label="Commission">
											<div style={{ display: "flex", alignItems: "center" }}>
												£
												<input
													ref={this.myRefCommission}
													name="agent_commission"
													value={this.state.agent_commission.toLocaleString()}
													onChange={this.handleInputChange}
													onBlur={this.handleCalulateTotal}
													type="number"
													className="ant-input"
													readOnly={!areWeUpdatingQuoteOrPolicy() || isViewMode} // if we are updating a policy, we can edit the commission
												/>

											</div>
										</Descriptions.Item>
										<Descriptions.Item label="Commission Rate">
											<div style={{ display: "flex", alignItems: "center" }}>
												%
												<input
													ref={this.myRefCommissionRate}
													name="agent_commission_rate"
													value={this.state.agent_commission_rate}

													type="number"
													className="ant-input"
													readOnly={!areWeUpdatingQuoteOrPolicy() || isViewMode} // if we are updating a policy, we can't change the commission rate
												/>

											</div>
										</Descriptions.Item>
										<Descriptions.Item label="Admin Fee">
											<div style={{ display: "flex", alignItems: "center" }}>
												£
												<input
													ref={this.myRefadmin_fee}
													name="admin_fee"
													value={this.state.admin_fee}
													onChange={this.handleInputChange}
													onBlur={this.handleCalulateTotal}
													type="number"
													className="ant-input"
													readOnly={!areWeUpdatingQuoteOrPolicy() || isViewMode} // if we are updating a policy, we can't change the admin fee
												/>
												{/* defaultValue={
														insuranceForMta.amendedQuoteData.admin_fee
													} */}
											</div>
										</Descriptions.Item>
										<Descriptions.Item label="IPT">
											{
												this.state.ipt_amt.toLocaleString()
											}
										</Descriptions.Item>
										<Descriptions.Item label="Total">
											{defaultCurrencyFormat(this.state.total /*insuranceForMta.amendedQuoteData.total */)}
										</Descriptions.Item>

										{policyNumber && <><Descriptions.Item label="Premium Adjustment (pro-rated)">
											{defaultCurrencyFormat(insuranceForMta.premiumAdjustment)}
										</Descriptions.Item>
											<Descriptions.Item label="Total Due/Refund">
												{defaultCurrencyFormat(this.state.totalDueRefund)}
											</Descriptions.Item>
											<Descriptions.Item label="Amendment Date">
												{new Date().toLocaleDateString()}
											</Descriptions.Item></>}
									</Descriptions>
									<Row>
										<Col
											xs={24}
											className="d-flex"
											style={{ marginTop: "2rem" }}
										>
											<Button className="mr-auto">
												{!policyNumber ? (
													<Link to={`/mta/amendquote/${quoteId}`}>
														{insuranceMtaService.overThePhone
															? "Change details"
															: "<< My details have changed"}
													</Link>
												) : (
													<Link to={`/mta/amendpolicy/${policyNumber}`}>
														{insuranceMtaService.overThePhone
															? "Change details"
															: "<< My details have changed"}
													</Link>
												)}
											</Button>
											{/* Change for payment or update */}
											{policyNumber ? (
												<>

													<Button

														className="ml-auto"
														type="primary"
														disabled={this.state.isUpdateButtonClicked || isViewMode}
														onClick={() => {
															if (this.state.totalDueRefund > 0) {
																this.sendPaymentIntent(quoteForPayment);
																this.setState({ isUpdateButtonClicked: true });

															} else if (this.state.totalDueRefund < 0) {
																this.paymentDueRefundNegative(quoteForPayment);
																/* this.setState({ isUpdateButtonClicked: true }); */

																//set time out !TODO 
																setTimeout(() => {
																	if (this.state.isStatusOk === true)
																		this.confirmInsurance()
																}, 2000);


															} else if (this.state.totalDueRefund === 0) {
																this.confirmInsurance()

															} else {
																alert("Something went wrong, no total due/refund");
															}
															// Button for updating policy

														}}
													>
														Update Policy
													</Button>
												</>

											) : (
												<Button
													className="ml-auto"
													type="primary"
													disabled={this.state.isUpdateButtonClicked || isViewMode}
													onClick={() => {
														this.setState({ isUpdateButtonClicked: true });
														// we call payment intent here with amended quote data
														this.sendPaymentIntent(quoteForPayment);
													}}
												>
													Update Quote
												</Button>
											)}
										</Col>
									</Row>
									<Row
										style={{
											marginTop: "2rem",
											marginBottom: "2rem",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
										}}
									>
										<Col>
											{policyNumber && isUpdateButtonClicked ? (<Button
												style={{
													width: "200px",
													height: "50px",
													fontSize: "16px",
													fontWeight: "bold",
													textTransform: "uppercase",
													display: showCard ? "none" : "block",
												}}
												type="primary"
												// TODO Call AMEND-CONFIRM API
												onClick={() => {
													if (this.state.totalDueRefund === 0) {
														// uradi nesto
													} else if (this.state.totalDueRefund < 0) {
														this.confirmInsurance()
													} else { // if policy is > 0, we call payment intent
														this.clickShowCard()
													}
												}}
											>
												Confirm Policy
											</Button>) : (typeof clientSecret === 'string' && clientSecret !== "" && <Button
												style={{
													width: "200px",
													height: "50px",
													fontSize: "16px",
													fontWeight: "bold",
													textTransform: "uppercase",
													display: showCard ? "none" : "block",
												}}
												type="primary"
												// TODO Call AMEND-CONFIRM API
												onClick={() => {
													this.clickShowCard()
												}}
											>
												Confirm Quote
											</Button>)}


										</Col>
									</Row>
									<Row>
										<Col
											xs={24}
											className="d-flex"
											style={{
												marginTop: "1rem",
												justifyContent: "center",
											}}
										>
											{(showCard) && (
												<Elements stripe={promise}>
													<StripeForm
														quoteForPayment={quoteForPayment}
														hidePostalCode={true}
														clientSecret={this.state.clientSecret}
													/>
												</Elements>
											)}
										</Col>

									</Row>

								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout >
		);
	}

	confirmInsurance = async (quoteId, policyNumber, totalDueRefund) => {
		const { insuranceMtaService } = this.props.context;

		const { insuranceForMta } = insuranceMtaService;

		await insuranceMtaService.confirmInsuranceMta()
			.then((result) => {
				if (result === 'SUCCESS') {

					this.props.history.push(`/policies`);

				}
			})

	};
}

export default MtaConfirm;
